var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.clickWrapper}},'v-btn',_vm.attributes,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }